import useTranslation from "next-translate/useTranslation";
import styles from "./styles/GameResult.module.css";
import { ResultTypes, StatusTypes } from "@chesshotel/constants";
import { useGamePlay } from "../../redux/gamePlay";
import { useUser } from "../../redux/user";

export default function GameResult({
  playingWhite,
  result,
  status,
  opponentName,
}) {
  const { t } = useTranslation("common");

  // const { playingWhite, result, status, opponent } = useGamePlay();
  // const opponentName = opponent.displayName;

  const { displayName } = useUser();

  const isWinner =
    (playingWhite && ResultTypes.WHITE_WINNS === result) ||
    (!playingWhite && ResultTypes.BLACK_WINNS === result);

  const loserName = isWinner ? opponentName : displayName;
  let statusMsg = "";
  switch (status) {
    case StatusTypes.TIME_UP:
      statusMsg = t("playerTimeUp", { player: loserName });
      break;
    case StatusTypes.QUIT:
      statusMsg = t("playerLeftGame", { player: loserName });
      break;
    case StatusTypes.CHECK_MATE:
      statusMsg = t("Checkmate!");
      break;
    case StatusTypes.RESIGN:
      statusMsg = t("playerResigned", { player: loserName });
      break;
    case StatusTypes.STALE_MATE:
      statusMsg = t("Stalemate!");
      break;
    case StatusTypes.DRAW:
      statusMsg = null;
      break;
    case StatusTypes.ABORT:
      statusMsg = t("Game aborted");
      break;
    default:
      statusMsg = null;
  }

  let resultScore = "";
  let statusStr = "";

  if (result === ResultTypes.WHITE_WINNS) {
    resultScore = "1 - 0";
  } else if (result === ResultTypes.BLACK_WINNS) {
    resultScore = "0 - 1";
  } else if (status === StatusTypes.ABORT) {
    resultScore = "";
  } else {
    resultScore = "1 - 1";
  }
  if (statusMsg) {
    statusStr = statusMsg + " ";
  } else {
    statusStr = "";
  }

  return (
    <div className={styles.cont}>
      <div className={styles.result}>{resultScore}</div>
      {/* <div className={styles.resultText}>{statusStr}</div> */}
    </div>
  );
}
